export default __webpack_public_path__ + "files/thumbnail-f9edf626cba5a71fa79f1aed298329b6.png";